import { createContext, useContext } from 'react'

export const TableCellContext = createContext(false)

export const useIsInsideTableCell = () => useContext(TableCellContext)
